// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>9</span>&nbsp;&nbsp;The Lord watches over the stranger in the land;<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;he upholds the orphan and widow;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but the way of the wicked he turns upside down.<br> </p> </div></div>";
// Exports
module.exports = code;